<template>
  <div class="loader" v-if="getState">
    <div class="loader__window">
      <img src="https://media.giphy.com/media/xTiTnD4d66fshHzTxK/giphy.gif" />
      <!-- <img src="https://media.giphy.com/media/8L0xFP1XEEgwfzByQk/giphy.gif"> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  computed: {
    getState() {
      return this.$store.getters.loader;
    },
  },
};
</script>

<style lang="stylus">
.loader
    display flex
    justify-content center
    align-items center
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    z-index 20
    pointer-events none

    &__window
        border-radius 10px
        overflow hidden
        img
            width 200px
</style>
